import { compute_data_root_fields } from './get_compute_data';
import {
  customer_panoramic_selection,
  last_transaction_selection,
  promocode_options_selection,
} from './get_customer_last_transaction_promocodes_data';
import {
  first_gateway_details_selection,
  payment_method_groups_panoramic_selection,
} from './get_payment_method_groups_panoramic';

export const get_initial_data_panoramic_query = `
  query Get_initial_data_panoramic($format: PaymentMethodOptionsFormat!, $sort: String, $decline_recovery_type: PaymentMethodOptionsDeclineRecoveryType) {${compute_data_root_fields}
    customer {${customer_panoramic_selection}}
    last_transaction {${last_transaction_selection}}
    promocode_options {${promocode_options_selection}}
    payment_method_groups(format: $format, sort: $sort, decline_recovery_type: $decline_recovery_type) {${payment_method_groups_panoramic_selection}}
    first_gateway_details(format: $format, sort: $sort, decline_recovery_type: $decline_recovery_type) {${first_gateway_details_selection}}
  }
`;

// Used only after a reload of a session in which the player had already
// switched tab: the tab-specific fields then carry the active tab's intent.
// Before any switch the query above is sent unchanged.
export const get_initial_data_panoramic_active_intent_query = `
  query Get_initial_data_panoramic($format: PaymentMethodOptionsFormat!, $sort: String, $decline_recovery_type: PaymentMethodOptionsDeclineRecoveryType, $active_intent: CashierIntent) {${compute_data_root_fields}
    customer {${customer_panoramic_selection}}
    last_transaction(active_intent: $active_intent) {${last_transaction_selection}}
    promocode_options {${promocode_options_selection}}
    payment_method_groups(format: $format, sort: $sort, decline_recovery_type: $decline_recovery_type, active_intent: $active_intent) {${payment_method_groups_panoramic_selection}}
    first_gateway_details(format: $format, sort: $sort, decline_recovery_type: $decline_recovery_type, active_intent: $active_intent) {${first_gateway_details_selection}}
  }
`;
